/**
 * The one look a disabled field has, in the values themselves.
 *
 * The `New` inputs paint it three different ways — `TextInput` and `TextArea` with Tailwind classes,
 * `SelectInput` through react-select's style objects, `FlatPickrDateInput` with inline styles on the
 * input flatpickr swaps in — and none of those can read each other's colours. Written down here so
 * the three still agree, and so changing the look is one edit rather than a hunt.
 *
 * The values are Tailwind's, because the class-based inputs are the ones the rest of the product is
 * measured against: `bg-gray-100`, `text-gray-500`, `border-gray-300`.
 */
export const DISABLED_INPUT = {
	/** `bg-gray-100` */
	background: '#f3f4f6',
	/** `text-gray-500` */
	text: '#6b7280',
	/** `border-gray-300` — the same border an enabled field has, so only the fill and the text move. */
	border: '#d1d5db',
} as const;
